// extracted by mini-css-extract-plugin
export default {"error-container":"error-page_error-container__wye86"};